import React from 'react';
import { Label } from 'components/Typography';
import FemaleLight from 'assets/img/gender/turquoise/female.png';
import MaleLight from 'assets/img/gender/turquoise/male.png';
import Female from 'assets/img/gender/female.png';
import Male from 'assets/img/gender/male.png';
import PropTypes from 'prop-types';
import { CheckIcon } from '../Select/styled';
import { Error } from '../TextInput/styled';
import { Container, Select } from './styled';

const GenderInput = ({ formik, size, label, name, variant, className, disabled }) => {
  const value = formik.values[name];

  const onChange = (gender) => {
    if (disabled) {
      return;
    }
    formik.setFieldValue(name, gender);
  };

  const renderLabel = (
    <Label htmlFor={name} variant={variant} size={size}>
      {label}
      {formik && !formik.errors.gender && formik.dirty && <CheckIcon />}
      {formik && formik.errors.gender && formik.dirty && formik.touched.gender && (
        <Error>{formik.errors.gender}</Error>
      )}
    </Label>
  );

  return (
    <div className={className}>
      {renderLabel}
      <Container size={size}>
        <Select
          variant={variant}
          isSelected={value === 'female'}
          disabled={disabled}
          onClick={() => onChange('female')}
        >
          <img src={variant === 'dark' ? FemaleLight : Female} alt="Female" />
          <p>Female</p>
        </Select>
        <Select
          variant={variant}
          isSelected={value === 'male'}
          onClick={() => onChange('male')}
          disabled={disabled}
        >
          <img src={variant === 'dark' ? MaleLight : Male} alt="Male" />
          <p>Male</p>
        </Select>
      </Container>
    </div>
  );
};

GenderInput.propTypes = {
  className: PropTypes.string,
  formik: PropTypes.object,
  name: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.string,
  variant: PropTypes.oneOf(['light', 'dark']),
  disabled: PropTypes.bool
};

GenderInput.defaultProps = {
  size: 'medium',
  variant: 'dark'
};

export default GenderInput;
